import type { PayloadActionCreator } from '@reduxjs/toolkit';

export type Action<T> = ReturnType<PayloadActionCreator<T>>;

export const convertFilesToFormData = (files: File[]) =>
    files.map((file) => {
        const formData = new FormData();
        formData.append('file', file);
        if (file.name) {
            formData.append('name', file.name);
        }
        if (file['description']) {
            formData.append('description', file['description']);
        }
        if (file['tag-id']) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            formData.append('tag-id', file['tag-id'].join(','));
        }

        return formData;
    });
